import api from "./API";

/**
 * Department Service
 * API service for managing departments (formerly patients)
 */

export const departmentService = {
  /**
   * Get all departments with optional filters and pagination
   * @param {Object} params - Query parameters (page, limit, search, departmentType, etc.)
   * @returns {Promise} API response with departments list
   */
  getDepartments: (params) => api.get("/departments", { params }),

  /**
   * Get a single department by ID
   * @param {string} id - Department ID
   * @returns {Promise} API response with department details
   */
  getDepartment: (id) => api.get(`/departments/${id}`),

  /**
   * Create a new department
   * @param {Object} data - Department data
   * @returns {Promise} API response with created department
   */
  createDepartment: (data) => api.post("/departments", data),

  /**
   * Update an existing department
   * @param {string} id - Department ID
   * @param {Object} data - Updated department data
   * @returns {Promise} API response with updated department
   */
  updateDepartment: (id, data) => api.put(`/departments/${id}`, data),

  /**
   * Delete a department (soft delete)
   * @param {string} id - Department ID
   * @returns {Promise} API response
   */
  deleteDepartment: (id) => api.delete(`/departments/${id}`),

  /**
   * Search departments by text query
   * @param {string} query - Search query
   * @param {Object} params - Additional query parameters
   * @returns {Promise} API response with matching departments
   */
  searchDepartments: (query, params = {}) => 
    api.get("/departments/search", { params: { q: query, ...params } }),

  /**
   * Get stock allocated to a specific department
   * @param {string} id - Department ID
   * @returns {Promise} API response with department stock information
   */
  getDepartmentStock: (id) => api.get(`/departments/${id}/stock`),

  /**
   * Get consumption statistics for a department
   * @param {string} id - Department ID
   * @param {Object} params - Query parameters (startDate, endDate, itemType, etc.)
   * @returns {Promise} API response with consumption data
   */
  getDepartmentConsumption: (id, params = {}) => 
    api.get(`/departments/${id}/consumption`, { params }),
};


